import * as React from "react";
import { Grid2 } from "@mui/material";

function DashBoardLinks() {
	// console.log("SeriesImageMaker");
	// console.log(mode);

	return (
		<div id="htmlPage" style={{ textAlign: "left" }}>
			<Grid2
				container
				spacing={2}
				direction="column"
				style={{
					display: "flex",
					padding: 100
				}}
			>
				{/* <Grid2 item xs={12}>
					<span className="db_label">DV Monitoring:</span>
					<a
						href="https://lookerstudio.google.com/reporting/b50e81e3-7e21-4f9e-9e5f-db8b1179149e"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "#42a5f5", paddingLeft: 10 }}
					>
						https://lookerstudio.google.com/reporting/b50e81e3-7e21-4f9e-9e5f-db8b1179149e
					</a>
				</Grid2> */}
				<Grid2 item xs={12}>
					<span className="db_label">Invoca Monitoring:</span>
					<a
						href="https://lookerstudio.google.com/reporting/6e7d9cf8-5495-4e7a-af10-9878d155661b"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "#42a5f5", paddingLeft: 10 }}
					>
						https://lookerstudio.google.com/reporting/6e7d9cf8-5495-4e7a-af10-9878d155661b
					</a>
				</Grid2>
				<Grid2 item xs={12}>
					<span className="db_label">Innovid Monitoring:</span>
					<a
						href="https://lookerstudio.google.com/reporting/7ba1a504-26ce-42ba-89b9-32374a6eea75"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "#42a5f5", paddingLeft: 10 }}
					>
						https://lookerstudio.google.com/reporting/7ba1a504-26ce-42ba-89b9-32374a6eea75
					</a>
				</Grid2>
				<Grid2 item xs={12}>
					<span className="db_label">NE Daily Lead Dashboard:</span>
					<a
						href="https://lookerstudio.google.com/reporting/70c0ef2e-f400-450c-800c-3328e44dee82"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "#42a5f5", paddingLeft: 10 }}
					>
						https://lookerstudio.google.com/reporting/70c0ef2e-f400-450c-800c-3328e44dee82
					</a>
				</Grid2>
				<Grid2 item xs={12}>
					<span className="db_label">GA4 KPI Monitoring:</span>
					<a
						href="https://lookerstudio.google.com/reporting/b53d6add-9d16-4069-96f0-91dd61faf2fd"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "#42a5f5", paddingLeft: 10 }}
					>
						https://lookerstudio.google.com/reporting/b53d6add-9d16-4069-96f0-91dd61faf2fd
					</a>
				</Grid2>
				<Grid2 item xs={12}>
					<span className="db_label">CAT Dealer Status:</span>
					<a
						href="https://lookerstudio.google.com/reporting/387ff313-a602-48a3-99db-5de25341ffb8"
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "#42a5f5", paddingLeft: 10 }}
					>
						https://lookerstudio.google.com/reporting/387ff313-a602-48a3-99db-5de25341ffb8
					</a>
				</Grid2>
			</Grid2>
		</div>
	);
}

export default DashBoardLinks;
